"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgMessageCircle02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.973 9.973 0 0 1-3.76-.732 9.877 9.877 0 0 0-.225-.089l-.005.001a7.078 7.078 0 0 0-.183.03l-3.587.597c-.16.027-.34.057-.496.069-.17.012-.44.017-.727-.106a1.5 1.5 0 0 1-.787-.787 1.525 1.525 0 0 1-.106-.727c.012-.156.042-.336.069-.496l.005-.03.593-3.557a7.06 7.06 0 0 0 .029-.183v-.005A9.975 9.975 0 0 1 2 12Z", fill: "currentColor" }) }))); };
exports.default = SvgMessageCircle02;
